import { render, staticRenderFns } from "./SwitchTest.vue?vue&type=template&id=6d61ec22&scoped=true&"
import script from "./SwitchTest.vue?vue&type=script&lang=js&"
export * from "./SwitchTest.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTest.vue?vue&type=style&index=0&id=6d61ec22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61ec22",
  null
  
)

export default component.exports